import React from "react";
import {
  Box,
  Container,
  Grid,
  Typography,
  Card,
  CardContent,
} from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import TrackChangesIcon from "@mui/icons-material/TrackChanges";

const VisionMission = () => {
  return (
    <Box sx={{ py: 8, backgroundColor: "background.default" }}>
      <Container maxWidth="lg">
        <Box sx={{ mb: 6, textAlign: "center" }}>
          <Typography
            variant="h2"
            component="h2"
            color="text.primary"
            sx={{ mb: 2, fontWeight: 600 }}
          >
            Our Vision & Mission
          </Typography>
          <Typography
            variant="subtitle1"
            color="text.secondary"
            sx={{ maxWidth: 700, mx: "auto" }}
          >
            Driving innovation in telecom and communication technology to
            connect the world more effectively
          </Typography>
        </Box>

        <Grid container spacing={4}>
          {/* Vision Card */}
          <Grid item xs={12} md={6}>
            <Card
              elevation={0}
              sx={{
                height: "100%",
                borderRadius: 3,
                backgroundColor: "primary.light",
                color: "primary.contrastText",
                transition: "transform 0.3s",
                "&:hover": {
                  transform: "translateY(-8px)",
                },
              }}
            >
              <CardContent sx={{ p: 4 }}>
                <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                  <VisibilityIcon sx={{ fontSize: 40, mr: 1 }} />
                  <Typography
                    variant="h4"
                    component="h3"
                    sx={{ fontWeight: 600 }}
                  >
                    Our Vision
                  </Typography>
                </Box>

                <Typography
                  variant="h6"
                  component="div"
                  paragraph
                  sx={{ fontStyle: "italic", mb: 3 }}
                >
                  "To be the global catalyst for next-generation
                  communication—enabling intelligent, secure, and real-time
                  connectivity across networks, platforms, and people."
                </Typography>

                <Typography variant="body1">
                  We envision a world where digital communication is
                  limitless—transcending barriers of scale, complexity, and
                  geography. ProtoDiag is committed to building intelligent,
                  interconnected ecosystems where businesses, telecom operators,
                  and users experience seamless and secure communication.
                </Typography>
              </CardContent>
            </Card>
          </Grid>

          {/* Mission Card */}
          <Grid item xs={12} md={6}>
            <Card
              elevation={0}
              sx={{
                height: "100%",
                borderRadius: 3,
                backgroundColor: "secondary.light",
                color: "secondary.contrastText",
                transition: "transform 0.3s",
                "&:hover": {
                  transform: "translateY(-8px)",
                },
              }}
            >
              <CardContent sx={{ p: 4 }}>
                <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                  <TrackChangesIcon sx={{ fontSize: 40, mr: 1 }} />
                  <Typography
                    variant="h4"
                    component="h3"
                    sx={{ fontWeight: 600 }}
                  >
                    Our Mission
                  </Typography>
                </Box>

                <Typography
                  variant="h6"
                  component="div"
                  paragraph
                  sx={{ fontStyle: "italic", mb: 3 }}
                >
                  "To empower enterprises and telecom operators with scalable,
                  API-first communication technologies—driving innovation,
                  reliability, and compliance in voice, messaging, and digital
                  engagement ecosystems."
                </Typography>

                <Typography variant="body1">
                  Our mission is to simplify and accelerate communication by
                  offering robust, carrier-grade platforms tailored for high
                  throughput, security, and compliance. Through real-time APIs,
                  intelligent routing engines, and AI-enhanced services, we
                  ensure that our partners stay ahead in delivering
                  mission-critical communication experiences globally.
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default VisionMission;
